import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import { combineReducers } from 'redux'
import notificationReducer from './slices/showNotificationSlice'
import loaderReducer from './slices/LoaderSlice'
import brandReducer from '../features/brands/slice/brandSlice'
import holidayReducer from '../features/holidays/slice/holidayslice'
import UserReducer from '../features/auth/slice/userSlice'
import trainingReducer from '../features/resources/slice/trainingslice'
import resReducer from '../features/resources/viewresources/slice/resoucesSlice'
import leaveTypeReducer from './../features/leavepolicy/leavetypes/slice/index'
import leavePolicyReducer from './../features/leavepolicy/slice/index'
import leavePolicyDetailsReducer from './../features/leavepolicy/editpolicy/slice/index'
import formReducer from '../features/forms/slice/formslice'
import jobInfoReducer from './../features/userslisting/slice/index'
import announcementSlice from '../features/announcements/slice/announcementslice'
import employeeFileSlice from '../features/emp-files/slice/employeeFileSlice'
import userListingSlice from '../features/userslisting/pages/slice/index'
import timeOffListingSlice from '../features/timeoffreq/slice'
import googleEventSlice from '../features/userslisting/sync/slice/eventSlice'

const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = combineReducers({
    auth: authReducer,
    user: UserReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)
const store = configureStore({
    reducer: {
        persistedReducers: persistedReducer,
        brands: brandReducer,
        showNotification: notificationReducer,
        loader: loaderReducer,
        holidays: holidayReducer,
        admintraining: trainingReducer,
        adminResource: resReducer,
        leaveTypes: leaveTypeReducer,
        leavePolicies: leavePolicyReducer,
        leavePolicyDetails: leavePolicyDetailsReducer,
        forms: formReducer,
        jobInfo: jobInfoReducer,
        announcements: announcementSlice,
        employeeFiles: employeeFileSlice,
        users: userListingSlice,
        timeOffRequests: timeOffListingSlice,
        googleEvents: googleEventSlice,
    },

    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
})
const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export { store, persistor }
